






























































import { Component } from 'vue-property-decorator';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import Mixin from '@/mixin';
import VNavigator from '@/components/items/VNavigator.vue';
import { validationMixin } from 'vuelidate';
import authService from '@/services/common/auth.service';
import VModalConfirmation from '@/components/popup/VModalConfirmation.vue';
import popupModule from '@/store/modules/common/popup.module';
import popup from '@/data/popup.json';

@Component({
  mixins: [validationMixin],
  name: 'reset-password',
  components: { VModalConfirmation, VNavigator },
  validations: {
    password: { required, minLength: minLength(6) },
    passwordConfirm: { required, samAsPassword: sameAs('password') }
  }
})
export default class ResetPassword extends Mixin {
  public password = '';
  public passwordConfirm = '';
  public token = '';

  public submit(event: Event) {
    event.preventDefault();
    this.$v?.$touch();
    if (!(this.$v?.$error || this.$v?.$invalid)) {
      authService
        .resetPassword({ new_password: this.password, token: this.token })
        .then(() => {
          this.showPopup(true);
        })
        .catch(() => {
          this.showPopup(false);
        });
    }
  }

  public async showPopup(isShow: boolean) {
    await Promise.all([
      popupModule.initPopup(popup.resetPassword),
      popupModule.setShowPopup(isShow)
    ]);
  }

  created() {
    this.token = this.$route.params.key;
  }
}
